import { createActionGroup, emptyProps } from '@ngrx/store';

export const FeatureDashboardActions = createActionGroup({
  source: 'Feature Dashboard',
  events: {
    Enter: emptyProps(),
  },
});
